const stripDataUrlPrefix = value => value.replace(/^data:[^;]+;base64,/, '').trim();

const detectImageMimeFromBase64 = base64 => {
  if (!base64) {
    return null;
  }

  const normalized = stripDataUrlPrefix(base64);

  if (normalized.startsWith('iVBORw0KGgo')) {
    return 'image/png';
  }

  if (normalized.startsWith('/9j/')) {
    return 'image/jpeg';
  }

  if (normalized.startsWith('R0lGOD')) {
    return 'image/gif';
  }

  if (normalized.startsWith('UklGR')) {
    return 'image/webp';
  }

  if (normalized.startsWith('PHN2Zy') || normalized.startsWith('PD94bWw')) {
    return 'image/svg+xml';
  }

  return null;
};

export const toImageDataUrl = (value, fallbackMime = 'image/png') => {
  if (!value) {
    return '';
  }

  if (value.startsWith('data:image/')) {
    return value;
  }

  if (value.startsWith('data:')) {
    return value;
  }

  const normalized = stripDataUrlPrefix(value).replace(/\s/g, '');
  const mime = detectImageMimeFromBase64(normalized) || fallbackMime;

  return `data:${mime};base64,${normalized}`;
};
